import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMicrosoftAuth } from "../context/MicrosoftAuthContext";
import "../css/Login.css";

const Login = () => {
  const { login, isAuthenticated, isLoading, isInitialized } = useMicrosoftAuth();
  const navigate = useNavigate();
  const [loginInProgress, setLoginInProgress] = useState(false);
  const [loginError, setLoginError] = useState(null);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, isLoading, navigate]);

  const handleMicrosoftLogin = async () => {
    if (loginInProgress || !isInitialized) {
      return; // Don't allow multiple login attempts or login before initialization
    }

    try {
      setLoginInProgress(true);
      setLoginError(null);
      const success = await login();
      if (success) {
        navigate("/dashboard");
      } else {
        setLoginError("Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Microsoft login error:", err);
      setLoginError(`Login error: ${err.message || "An unexpected error occurred"}`);
    } finally {
      setLoginInProgress(false);
    }
  };

  return (
    <div className="login2-container">
      {/* Left side with CNG logo */}
      <div className="login2-left-panel">
        <div className="cng-logo-container">
          <img
            src="/assets/logo.svg"
            alt="CNG Property Group"
            className="cng-logo-large"
          />
        </div>
      </div>

      {/* Right side with login form */}
      <div className="login2-right-panel">
        {/* Vertical line */}
        <div className="login2-vertical-line-top"></div>

        {/* Login content */}
        <div className="login2-content">
          <div className="login2-header">
            <h1>LOG IN TO YOUR ACCOUNT</h1>
            <p>
              You can access your account using Microsoft. Click on the button
              below to sign in.
            </p>
            {!isInitialized && !isLoading && (
              <div className="alert alert-info mt-3">
                Initializing authentication. Please wait...
              </div>
            )}
          </div>

          {loginError && (
            <div className="alert alert-danger" role="alert">
              {loginError}
            </div>
          )}

          <button
            className="ms-login-button"
            onClick={handleMicrosoftLogin}
            disabled={loginInProgress || isLoading || !isInitialized}
          >
            <div className="ms-logo">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_520_7046)">
                  <path d="M0.5 9.27209V13.9326L7.15352 14.888V9.27209H0.5Z" fill="black" />
                  <path d="M7.15352 2.1131L0.5 3.06852V7.72899H7.15352V2.1131Z" fill="black" />
                  <path d="M16.5 7.729V0.6922L8.69775 1.81204V7.729H16.5Z" fill="black" />
                  <path d="M8.69775 15.1891L16.5 16.3078V9.27209H8.69775V15.1891Z" fill="black" />
                </g>
                <defs>
                  <clipPath id="clip0_520_7046">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span>
              {loginInProgress || isLoading ? "Loading..." : "Login with Microsoft"}
            </span>
          </button>
        </div>

        {/* Vertical line */}
        <div className="login2-vertical-line-bottom"></div>
      </div>
    </div>
  );
};

export default Login;